<div class="controls-container">
    <div class="controls-header">Cards</div>

    <div class="controls-sub-header">Card</div>

    <div class="controls-cards">
        <pm-card>
            <div card-header class="card-header">PM-Card</div>
            <div card-body class="card-body">This goes to the body instead</div>
            <div card-footer class="card-footer"><pm-button>Go To</pm-button></div>
        </pm-card>

        <pm-card CardClass="card-theme-1">
            <div card-body class="card-body">This goes to the body instead</div>
        </pm-card>

        <pm-card>
            <div card-header class="controls-card-header-theme1">PM-Card</div>
            <div card-body class="controls-card-body">This goes to the body instead</div>
        </pm-card>

        <pm-card>
            <div card-header class="controls-card-header-theme2">PM-Card </div>
            <div card-body class="controls-card-body"><pm-donut-chart></pm-donut-chart></div>
        </pm-card>

        <pm-card>
            <div card-header
                 class="controls-card-header-theme3">Version</div>
            <div card-body>
                <pm-area-chart style="display: flex; justify-content: center; padding-top: 10px; padding-bottom: 20px;"></pm-area-chart>
            </div>
            <div card-footer
                 class="card-footer">
                 Version 5 <pm-link>Patch Notes</pm-link>
            </div>
        </pm-card>
    </div>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/cards/cards.html